/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export class ApiClient {
    get apiClient() {
        return this.httpClient;
    }
    constructor(httpClient) {
        if ((httpClient === null || httpClient === void 0 ? void 0 : httpClient.__type) === 'legacy-client') {
            this.alfrescoApi = httpClient;
        }
        else {
            this.httpClient = httpClient;
        }
    }
    post(options) {
        return this.apiClient.post(options);
    }
    put(options) {
        return this.apiClient.put(options);
    }
    get(options) {
        return this.apiClient.get(options);
    }
    delete(options) {
        return this.apiClient.delete(options);
    }
    errorMessage(param, methodName) {
        return `Missing param ${param} in ${methodName}`;
    }
}
